import { render, staticRenderFns } from "./CommitteeList.vue?vue&type=template&id=0e154f58"
import script from "./CommitteeList.vue?vue&type=script&lang=js"
export * from "./CommitteeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports